<template>
  <div class="state-header">
    <ConfirmationDialog
      v-if="deletable"
      :uid="uid"
      :entity="deletable"
      handle-confirm-on-parent
      @confirm="removeState"
      @cancel="deletable = null"
    />

    <StateModal v-model="stateModal" :edit-item="state" :edit-item-order="order" />

    <div class="name">
      {{ state.name }}
      <LmTooltip> {{ state.name }} </LmTooltip>
    </div>

    <span class="state-options">
      <q-btn class="drag-handle q-pa-sm" size="sm" flat dense color="primary" icon="fal fa-arrows">
        <LmTooltip> Drag and drop the state to another location </LmTooltip>
      </q-btn>

      <q-btn
        :ripple="false"
        size="sm"
        class="q-pa-sm"
        flat
        dense
        color="primary"
        icon="fas fa-plus"
        @click="$emit('new-todo')"
      >
        <LmTooltip>Add new todo</LmTooltip>
      </q-btn>

      <q-btn-dropdown
        v-model="openDropdown"
        :ripple="false"
        content-class="no-border-radius"
        flat
        outline
        dense
        align="right"
      >
        <template #label>
          <q-btn :ripple="false" flat dense color="primary" icon="fal fa-ellipsis-h" />
        </template>

        <div class="option" @click="onEdit">
          <q-icon color="teal" size="1.1rem" text-color="white" name="edit" />
          Edit
        </div>

        <div class="option" @click="onDelete">
          <q-icon color="teal" size="1.1rem" text-color="white" name="delete" />
          Remove
        </div>
      </q-btn-dropdown>
    </span>
  </div>
</template>

<script>
import { uid } from 'quasar'
import * as apiTo from '../api'
import { generateDialogParams } from '@/lib/generic.utils'
import { mapMutations, mapActions } from 'vuex'
// Components
import StateModal from './StateModal'
import ConfirmationDialog from '@components/lm-blocks/Dialog'

export default {
  components: {
    StateModal,
    ConfirmationDialog
  },

  props: {
    state: Object,
    order: Number
  },

  data: () => ({
    openDropdown: false,
    stateModal: false,
    uid: uid(),
    deletable: null
  }),

  methods: {
    ...mapMutations('kanban-board', ['deleteState']),
    ...mapActions('kanban-board', ['deleteStateWithTodos']),

    optionClicked(option) {
      this.openDropdown = false
      this.$emit(option)
    },

    onEdit() {
      this.openDropdown = false
      this.stateModal = true
    },

    onDelete() {
      this.openDropdown = false
      this.deletable = this.state
      apiTo.getDeleteConfirmation(this.state.id).then(response => {
        this.$store.commit('updateGlobalDialogContent', generateDialogParams(this.uid, 'deleteSingle', response.data))
        this.$store.commit('updateGlobalDialogVisibility', {
          uid: this.uid,
          value: true
        })
      })
    },

    removeState() {
      apiTo.deleteState(this.state.id).then(() => {
        if (!this.state.tasks.length) this.deleteState(this.state.id)
        else this.deleteStateWithTodos(this.state.id)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'
>>> .q-btn-dropdown {
  padding 0
}

>>> .drag-handle {
  cursor move
}

>>> .q-btn {
  transition none !important
}

.option {
  padding 10px 35px 10px 10px
  cursor pointer

  &:hover {
    background $lm-grey
  }
}

.option + .option {
  border-top 1px solid $lm-grey
}

.state-header {
  display grid
  grid-auto-flow column
  align-items center
  justify-content space-between
  font-weight 500
  font-size 1.125rem
  user-select none
  gap: 15px;

  > .name {
    white-space nowrap
    text-overflow ellipsis
    overflow hidden
  }

  .options {
    font-size 1.3rem
    cursor pointer
    height 12px
    line-height 5px
    letter-spacing -1px
  }
}
</style>
